import { render, staticRenderFns } from "./WhiteSpace.vue?vue&type=template&id=47e7f9a8&"
var script = {}
import style0 from "./WhiteSpace.vue?vue&type=style&index=0&id=47e7f9a8&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports